<template>
  <div>
    <custom-square :title="'LABELS'">
      <template slot="squareInfo">
        <div v-if="annotationsObject !== null">
          <table class="anno-table" v-if="annotationsObject.length > 0">
            <tr
              v-for="(item, index) in annotationsObject.slice(
                currentPage * 5 - 5,
                currentPage * 5
              )"
              :key="index"
              :class="index % 2 === 0 ? '' : 'anno-table__grey-row'"
            >
              <td>
                <div>{{ convertData(item.created_at) }}</div>
              </td>
              <td class="labels-cell-button">
                <button
                  v-if="item.file !== null"
                  class="anno-table__btn"
                  :disabled="item.id === labelsID"
                  @click="showFile(item.id)">Show</button>
                <button
                  v-if="item.file !== null"
                  class="anno-table__btn"
                  @click="editDatapoint(item.id)">Edit</button>
                <button
                  v-if="item.file !== null"
                  class="anno-table__btn"
                  @click="downloadFile(item.file)">
                  Download
                </button>
                <button
                  v-if="item.file !== null"
                  class="anno-table__btn"
                  @click="deleteFile(item.id)">
                  Delete
                </button>
                <h4 v-else class="m-0">No file</h4>
              </td>
            </tr>
          </table>

          <v-pagination
            v-model="currentPage"
            :page-count="pagesCount"
            :classes="paginationClasses"
            v-if="pagesCount > 1"/>

          <img           
            v-if="image"          
            :src="image" 
            class="w-100"
            @click="onClickImage()"/>
        </div>

        <div v-else>No annotations found</div>
        <!-- <img :src="annotationsObject.file" alt class="annotations__image" /> -->
      </template>
    </custom-square>

    <b-modal v-model="modalPreview" scrollable size="xl" hide-header ok-only>
      <img           
        v-if="image"          
        :src="image" 
        class="w-100"/>
    </b-modal>
  </div>    
</template>

<script>
import { mapState } from "vuex";
import vPagination from "vue-plain-pagination";
import CustomSquare from "../../../../customReusableComponents/CustomSquare";

export default {
  components: {
    CustomSquare,
    vPagination
  },
  computed: {
    ...mapState({
      labelsID: state => state.datapoints.labelsID,
      token: state => state.token
    }),
    detailsObject() {
      return this.$store.getters.detailsObject;
    },
    annotationsObject() {
      return this.$store.getters.annotationsObject;
    },
    pagesCount() {
      return Math.ceil(this.$store.getters.annotationsObject.length / 5);
    },
    annoPagination() {
      return this.annotationsObject.slice(10, 15);
    },
    image() {
      let img = this.$store.getters.getLabelImage

      if (!img || img.split('.').pop() == "zip")
        return null
      return this.$store.getters.getLabelImage;
    }
  },
  data() {
    return {
      currentPage: 1,
      paginationClasses: {
        ul: "pagination",
        li: "pagination__li",
        liActive: "active",
        liDisable: "disabled",
        button: "pagination__item"
      },
      allAnnotations: [],
      annotationsFromPage: [],
      modalPreview: false
    };
  },
  methods: {
    convertData(data) {
      return new Date(data)
        .toDateString()
        .split(" ")
        .slice(1, 4)
        .join(" ");
    },
    showFile(id) {
      this.$store.dispatch("showLabelImage", id);
    },
    editDatapoint (id) {
      window.open(`https://annotator.saliency.ai/dashboard/${id}/${this.token}/`, '_blank')
	  },
    downloadFile (file_url) {
      window.open(file_url)
    },
    deleteFile(id) {
      this.$store.dispatch("deleteLabelImage", id);
    },
    onClickImage () {
      this.modalPreview = true
    }
  }
};
</script>

<style lang="scss" scoped>
.annotations {
  &__image {
    width: 250px;
  }
}

.anno-table {
  width: 100%;
  text-align: center;
  border: 1px solid #dddddd;
  margin-bottom: 10px;

  td {
    border: 1px solid #dddddd;
  }

  td.labels-cell-button {
    height: 40px;
  }

  &__grey-row {
    background-color: #fffcf5;
  }

  &__btn {
    border: none;
    color: white;
    background-color: #66615b;
    text-transform: uppercase;
    font-weight: bold;
    padding: 4px 8px;
    border-radius: 2px;
    margin: 5px;

    &:hover {
      background-color: #403d39;
    }

    &:disabled {
      background-color: #b4afa6;
    }
  }
}
</style>
